import PropTypes from 'prop-types';
export default PropTypes.shape({
  min: PropTypes.number,
  max: PropTypes.number
});